import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ServicesHero from "../components/ServicesHero";
import ServicesContent from "../components/ServicesContent";
import CTA from "../components/CTA";

const ServicesPage = () => {
  return (
    <>
      <Navbar />
      <ServicesHero />
      <ServicesContent/>
      <CTA />
      <Footer />
    </>
  );
};

export default ServicesPage;